module.exports = __webpack_public_path__ + "img/1.c6ffba2c.png";